import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { node, string } from 'prop-types';
import { ContainerTitle, ContainerIcon } from './dropdown.styles';
import { useDropdownContext } from './dropdown-context';

const DropdownTitle = _ref => {
  let {
    children,
    fill
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "fill"]);

  const {
    isOpen,
    handleOnClick,
    pointing
  } = useDropdownContext();
  return /*#__PURE__*/React.createElement(ContainerTitle, _extends({}, props, {
    isOpen: isOpen,
    pointing: pointing,
    onClick: handleOnClick,
    "data-testid": "dropdown-title"
  }), children, /*#__PURE__*/React.createElement(ContainerIcon, {
    fill: fill,
    rotated: isOpen
  }));
};

process.env.NODE_ENV !== "production" ? DropdownTitle.propTypes = {
  children: node,
  fill: string,
  as: string
} : void 0;
DropdownTitle.defaultProps = {
  children: null,
  fill: 'text.base',
  underlineOnHover: false
};
DropdownTitle.displayName = 'DropdownTitle';
export default DropdownTitle;